export default function Marker() {
  return (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 10 10">
    <g id="Mask_Group_335" data-name="Mask Group 335">
      <path id="location-pin" d="M5,0A3.768,3.768,0,0,0,1.25,3.777c0,2.96,3.4,6.015,3.542,6.144a.313.313,0,0,0,.416,0C5.352,9.793,8.75,6.737,8.75,3.777A3.768,3.768,0,0,0,5,0ZM5,5.833A2.083,2.083,0,1,1,7.083,3.75,2.086,2.086,0,0,1,5,5.833Z" fill="#5a93ff" />
    </g>
  </svg>)
}

